import React, { useState } from "react";
import Card from "components/card";
import { MdClose, MdSearch } from "react-icons/md";
import { FaPlane } from "react-icons/fa";

const FlightSearchModal = ({ isOpen, onClose, onSearch }) => {
  const [searchData, setSearchData] = useState({
    from: "",
    to: "",
    departureDate: "",
    passengers: "1"
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(searchData);
    setSearchData({ from: "", to: "", departureDate: "", passengers: "1" });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
      <Card extra="w-[500px] bg-white/95 dark:bg-navy-800/95 backdrop-blur-sm border border-white/20 dark:border-navy-600/50 shadow-2xl">
        <div className="bg-[#5a88c6] shadow-lg p-6 rounded-t-[20px] relative overflow-hidden">
          <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-16 translate-x-16"></div>
          <div className="relative z-10 flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="rounded-2xl bg-white/20 backdrop-blur-sm p-3">
                <FaPlane className="h-6 w-6 text-white" />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white">Search Flights</h3>
                <p className="text-white/80 text-sm">Find available flights</p>
              </div>
            </div>
            <button onClick={onClose} className="rounded-full bg-white/20 p-2 text-white hover:bg-white/30 transition-colors">
              <MdClose className="h-6 w-6" />
            </button>
          </div>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-semibold text-slate-700 dark:text-white mb-2">From</label>
              <input
                type="text"
                placeholder="e.g., New York (JFK)"
                value={searchData.from}
                onChange={(e) => setSearchData({...searchData, from: e.target.value})}
                className="w-full rounded-xl border-2 border-slate-200 dark:border-navy-600 p-3 focus:border-yellow-500 focus:outline-none bg-white dark:bg-navy-800 text-slate-900 dark:text-white"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-slate-700 dark:text-white mb-2">To</label>
              <input
                type="text"
                placeholder="e.g., Los Angeles (LAX)"
                value={searchData.to}
                onChange={(e) => setSearchData({...searchData, to: e.target.value})}
                className="w-full rounded-xl border-2 border-slate-200 dark:border-navy-600 p-3 focus:border-yellow-500 focus:outline-none bg-white dark:bg-navy-800 text-slate-900 dark:text-white"
                required
              />
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-semibold text-slate-700 dark:text-white mb-2">Departure Date</label>
              <input
                type="date"
                value={searchData.departureDate}
                onChange={(e) => setSearchData({...searchData, departureDate: e.target.value})}
                className="w-full rounded-xl border-2 border-slate-200 dark:border-navy-600 p-3 focus:border-yellow-500 focus:outline-none bg-white dark:bg-navy-800 text-slate-900 dark:text-white"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-slate-700 dark:text-white mb-2">Passengers</label>
              <select
                value={searchData.passengers}
                onChange={(e) => setSearchData({...searchData, passengers: e.target.value})}
                className="w-full rounded-xl border-2 border-slate-200 dark:border-navy-600 p-3 focus:border-yellow-500 focus:outline-none bg-white dark:bg-navy-800 text-slate-900 dark:text-white"
              >
                <option value="1">1 Passenger</option>
                <option value="2">2 Passengers</option>
                <option value="3">3 Passengers</option>
                <option value="4">4 Passengers</option>
              </select>
            </div>
          </div>
          
          <div className="flex space-x-4 pt-6">
            <button
              type="submit"
              className="flex-1 rounded-xl bg-[#5a88c6] py-3 px-6 text-white font-semibold hover:bg-[#4a7bb6] transition-all duration-200 flex items-center justify-center space-x-2"
            >
              <MdSearch className="h-5 w-5" />
              <span>Search Flights</span>
            </button>
            <button
              type="button"
              onClick={onClose}
              className="flex-1 rounded-xl bg-slate-100 dark:bg-navy-700 py-3 px-6 text-slate-700 dark:text-white font-semibold hover:bg-slate-200 dark:hover:bg-navy-600 transition-colors"
            >
              Cancel
            </button>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default FlightSearchModal;